import React, { useState } from "react";
import casestudy from "../../assets/FlipImages/1.png";
import {
  TextField,
  Button,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import financeacc from "../../assets/images/blogs/finance-acc-1.png";

const FinancialAccountingTrends = () => {
  const [comment, setComment] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [saveInfo, setSaveInfo] = useState(false);
  const [comments, setComments] = useState([]);

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleWebsiteChange = (event) => {
    setWebsite(event.target.value);
  };

  const handleSaveInfoChange = (event) => {
    setSaveInfo(event.target.checked);
  };

  const handleCommentSubmit = () => {
    if (comment.trim() && name.trim() && email.trim()) {
      setComments([...comments, { comment, name, email, website }]);
      setComment("");
      setName("");
      setEmail("");
      setWebsite("");
      setSaveInfo(false);
    }
  };

  return (
    <>
      <style jsx>{`
        h4 {
          font-size: 18px;
        }
        h3 {
          font-size: 28px;
        }
        span {
          font-size: 16px;
        }
        p {
          font-size: 16px;
        }
        li {
          font-size: 16px;
          font-weight: 500;
        }
        .mainCard {
          height: 20rem;
        }
        .circle {
          width: 100px;
          height: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          overflow: hidden;
        }
        i {
          color: #072f5f;
        }
        ul {
          padding-left: 17px;
        }
        @media (max-width: 574px) {
          .mTop {
            margin-top: 30px;
          }
          p {
            font-size: 18px;
          }
          .img-fluid {
            min-height: 100px;
          }
          .container-fluid {
            padding-left: 15px;
            padding-right: 15px;
          }
        }
        @media (min-width: 992px) {
          /* for banner image */
          .bmTop {
            margin-top: 130px;
          }
        }
        @media (max-width: 574px) {
          .banner-image {
            margin-top: 70px; /* Adjust this value for mobile view */
          }
        }
      `}</style>

      <section className="">
        <div
          className="d-flex justify-content-center align-items-center banner-image"
          style={{
            background: `url(${casestudy}) no-repeat center`,
            backgroundSize: "cover",
            height: "200px",
          }}
        >
          <div className="d-flex flex-column justify-content-center align-items-center">
            <h3
              className="text-white text-uppercase text-center"
              style={{ fontWeight: "bold", marginTop: "10px" }}
            >
              Financial Accounting Trends in 2025: <br/> Cloud Tech, Outsourcing & Smart Forecasting
            </h3>
          </div>
        </div>
        <div className="container-fluid">
          <div
            className="d-flex row justify-content-center align-items-start"
            style={{ gap: "2rem" }}
          >
            <div
              className="col-lg-8 mt-50 mb-50 border shadow"
              style={{ padding: "2rem" }}
            >
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div>
                  <div
                    style={{
                      background: "#072f5f",
                      display: "inline",
                      width: "fit-content",
                      padding: "0.2rem 1rem 0.2rem 1rem",
                    }}
                  >
                    <small
                      className="text-uppercase text-white"
                      style={{ fontWeight: "600", fontSize: "15px" }}
                    >
                      Introduction
                    </small>
                  </div>
                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "18px",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      ></span>
                    </div>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      As we move deeper into the digital age, the landscape of
                      financial accounting is undergoing significant
                      transformations. By 2025, three key trends are set to
                      dominate the industry: cloud technology, outsourcing, and
                      smart forecasting. These trends not only enhance
                      efficiency but also empower financial professionals to
                      provide better services to their clients. In this blog, we
                      will explore each of these trends and their implications
                      for the future of financial accounting.
                    </p>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        1. Cloud Technology
                      </span>
                    </div>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      Cloud technology has revolutionized the way businesses
                      manage their financial data. By 2025, we can expect an
                      even greater reliance on cloud-based accounting solutions.
                      The advantages of cloud technology are numerous,
                      including:
                    </p>

                    <ul
                      className="text-dark servicep"
                      style={{ listStyleType: "disc", textAlign: "justify" }}
                    >
                      <li>
                        • FP&A is essential for forecasting future performance
                        and enabling data-driven decisions. We work closely with
                        clients to build robust financial models, identify key
                        data trends, and uncover actionable insights. This
                        forward-looking approach allows firms to anticipate
                        risks and seize opportunities proactively.
                      </li>

                      <li>
                        • Cost Efficiency: With cloud solutions, businesses can
                        reduce the costs associated with traditional IT
                        infrastructure. Subscription-based models often provide
                        a more manageable expense, allowing companies to scale
                        their accounting needs without significant upfront
                        investments.
                      </li>

                      <li>
                        • Enhanced Security: Cloud providers invest heavily in
                        security measures to protect sensitive financial data.
                        Features such as encryption, multi-factor
                        authentication, and regular backups ensure that
                        information is safe from breaches and data loss.
                      </li>
                    </ul>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      As cloud technology continues to evolve, we can expect
                      more advanced features, such as artificial intelligence
                      (AI) integration, which will automate routine tasks and
                      improve data analysis.
                    </p>

                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        2. Outsourcing
                      </span>
                    </div>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      Outsourcing has become a strategic move for many
                      businesses looking to streamline operations and cut costs.
                      By 2025, the trend of outsourcing financial accounting
                      functions is likely to grow, driven by several factors:
                    </p>
                    <ul
                      className="text-dark servicep"
                      style={{ listStyleType: "disc", textAlign: "justify" }}
                    >
                      <li>
                        • Focus on Core Competencies: By outsourcing accounting
                        tasks, businesses can concentrate on their core
                        operations while leaving financial management to
                        experts. This allows companies to allocate resources
                        more effectively and enhance productivity.
                      </li>

                      <li>
                        • Access to Expertise: Outsourcing provides access to a
                        pool of skilled professionals who are up-to-date with
                        the latest regulations and accounting standards. This
                        expertise can lead to improved compliance and more
                        accurate financial reporting.
                      </li>

                      <li>
                        • Scalability: As businesses grow, their accounting
                        needs change. Outsourcing allows for flexibility in
                        scaling services up or down based on demand, ensuring
                        that companies only pay for what they need.
                      </li>
                    </ul>
                    <p
                      className="text-dark servicep"
                      style={{ textAlign: "justify" }}
                    >
                      The rise of outsourcing will also lead to the emergence of
                      specialized firms that cater to specific industries,
                      providing tailored services that address unique accounting
                      challenges.
                    </p>
                  </div>

                  <div className="mt-15">
                    <span
                      className="text-capitalize"
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "700",
                        color: "#002249",
                      }}
                    >
                      3. Smart Forecasting
                    </span>
                  </div>
                  <p
                    className="text-dark servicep"
                    style={{ textAlign: "justify" }}
                  >
                    Smart forecasting is set to become a game-changer in
                    financial accounting by 2025. Leveraging advanced analytics
                    and machine learning, financial professionals will be able
                    to make more accurate predictions about future financial
                    performance. Key benefits of smart forecasting include:{" "}
                  </p>
                  <ul
                    className="text-dark servicep"
                    style={{ listStyleType: "disc", textAlign: "justify" }}
                  >
                    <li>
                      • Data-Driven Decisions: By utilizing historical data and
                      market trends, businesses can make informed decisions that
                      drive growth and profitability. Smart forecasting tools
                      enable financial professionals to identify patterns and
                      trends that may not be immediately apparent.
                    </li>

                    <li>
                      • Scenario Planning: With the ability to simulate various
                      scenarios, businesses can prepare for potential challenges
                      and opportunities. This proactive approach to financial
                      management allows companies to navigate uncertainties with
                      confidence.
                    </li>

                    <li>
                      • Improved Budgeting: Smart forecasting enhances the
                      budgeting process by providing more accurate projections.
                      This leads to better resource allocation and financial
                      planning, ultimately contributing to the overall success
                      of the organization.
                    </li>
                  </ul>

                  <img
                    src={financeacc}
                    style={{
                      display: "block",
                      margin: "1rem auto",
                      width: "350px",
                      height: "270px",
                    }}
                  />
                  <div>
                    <div className="mt-15">
                      <span
                        className="text-capitalize"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "700",
                          color: "#002249",
                        }}
                      >
                        Conclusion
                      </span>
                    </div>
                    <ul
                      className="text-dark servicep"
                      style={{ listStyleType: "disc", textAlign: "justify" }}
                    >
                      <li>
                        As we look ahead to 2025, the integration of cloud
                        technology, outsourcing, and smart forecasting will
                        redefine the financial accounting landscape. These
                        trends will not only enhance operational efficiency but
                        also empower financial professionals to deliver more
                        strategic insights to their clients. By embracing these
                        changes, businesses can position themselves for success
                        in an increasingly competitive environment. Staying
                        informed about these trends will be crucial for
                        financial professionals aiming to thrive in the evolving
                        world of accounting.
                      </li>
                    </ul>
                  </div>

                  <Box
                    mt="2rem"
                    p="2rem"
                    border="1px solid #ddd"
                    borderRadius="8px"
                  >
                    <Typography variant="h5" gutterBottom>
                      Leave a Comment
                    </Typography>
                    <TextField
                      label="Message"
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={4}
                      value={comment}
                      onChange={handleCommentChange}
                      margin="normal"
                    />
                    <Box display="flex" gap="1rem">
                      <TextField
                        label="Name"
                        variant="outlined"
                        fullWidth
                        value={name}
                        onChange={handleNameChange}
                        margin="normal"
                      />
                      <TextField
                        label="Email"
                        variant="outlined"
                        fullWidth
                        value={email}
                        onChange={handleEmailChange}
                        margin="normal"
                      />
                    </Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={saveInfo}
                          onChange={handleSaveInfoChange}
                        />
                      }
                      label="Save my name, email, and website in this browser for the next time I comment."
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleCommentSubmit}
                      style={{ backgroundColor: "rgb(0, 34, 73)" }}
                    >
                      Send Comment
                    </Button>
                  </Box>
                  <Box mt="2rem">
                    {comments.map((cmt, index) => (
                      <Box
                        key={index}
                        mt="1rem"
                        p="1rem"
                        border="1px solid #ddd"
                        borderRadius="8px"
                      >
                        <Typography variant="body1">{cmt.comment}</Typography>
                        <Typography variant="body2" color="textSecondary">
                          {cmt.name} - {cmt.email}
                          {cmt.website && ` - ${cmt.website}`}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FinancialAccountingTrends;
